import { useAllOrders } from "../../hooks/orders"
import { useParams } from "react-router-dom"
import { Button, Container, Flex } from "@chakra-ui/react"
import Printer from "../../components/Printing/Printer"

const PrintAllPage = () => {
  const { linkId, category } = useParams()
  const { orders, isLoading } = useAllOrders()

  return (
    <Container maxW="container.md">
      {!isLoading && (
        <Printer
          orders={orders.filter((item) => item.linkId === linkId)}
          category={category}
        />
      )}
      <Flex id="footer" w="full" p={4} align="center" justify="center">
        <Container maxW="container.md">
          <Button
            w="full"
            size="lg"
            colorScheme="teal"
            onClick={() => {
              window.print()
            }}
          >
            Stampa
          </Button>
        </Container>
      </Flex>
    </Container>
  )
}

export default PrintAllPage
